// @flow
import itemReordered from 'app/common/redux/actions/feeds/itemReordered';
import ResourceFactory from 'app/common/lib/ResourceFactory';
import type { Thunk } from 'app/common/redux/types';
import { profileBoardsFeedId } from 'app/common/redux/selectors/profileBoards';
import { reorderItems } from 'app/common/redux/reducers/feeds';

type ReorderProfileBoardsOptions = {|
  boardIds: Array<string>,
  sourceIndex: number,
  targetIndex: number,
|};

export default function reorderProfileBoards({
  boardIds,
  sourceIndex,
  targetIndex,
}: ReorderProfileBoardsOptions): Thunk<void> {
  return (dispatch, getState) => {
    const { viewer } = getState();
    const viewerUsername = viewer.isAuth && viewer.username;
    if (!viewerUsername) {
      return;
    }
    dispatch(
      itemReordered({
        feedType: 'profileBoards',
        feedId: profileBoardsFeedId(viewerUsername, 'custom'),
        itemType: 'board',
        sourceItemId: boardIds[sourceIndex],
        targetItemId: boardIds[targetIndex],
      }),
    );
    const reorderedBoardIds = reorderItems(boardIds, sourceIndex, targetIndex);
    ResourceFactory.create('BoardsReorderResource', {
      board_ids: reorderedBoardIds,
    }).callUpdate({ showError: false });
  };
}
